import { Box, Tooltip } from '@mui/material'
import React from 'react'
import RestoreIcon from '@mui/icons-material/Restore';

const ModuleWiseRevisionHistory = ({ViewGlobalHistory}) => {
  return (
    <Box>
      <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={ViewGlobalHistory} sx={{cursor: "pointer", position: "relative",top:'8px'}}color='primary'/></Tooltip>
    </Box>
  )
}

export default ModuleWiseRevisionHistory